export function orderByKeys(items, order = [], getKey) {
    const positions = new Map();

    order.forEach((key, index) => {
        if (!positions.has(key)) {
            positions.set(key, index);
        }
    });

    return items
        .map((item, index) => ({ item, index }))
        .sort((left, right) => {
            const leftPosition = positions.get(getKey(left.item)) ?? order.length;
            const rightPosition = positions.get(getKey(right.item)) ?? order.length;

            return ( leftPosition - rightPosition || left.index - right.index );
        }).map(({ item }) => item);
}